import { Card } from '../components/UI';
import { CTABand, PageShell } from '../components/Chrome';

function LedgerRow({ label, value }) {
  return <div className="ledger-row"><span>{label}</span><span className="ledger-fill" aria-hidden="true" /><span className="ledger-val">{value}</span></div>;
}

export function PricingPage() {
  return (
    <PageShell active="pricing" cta={<CTABand heading="Want a clear number for your problem?" />}>
      <section className="site-wrap page-head">
        <div className="overline">Pricing</div>
        <h1>Fair prices, no surprises.</h1>
        <p className="hero-sub">Small jobs stay simple. Larger work is discussed and quoted before it begins.</p>
      </section>
      <section className="site-wrap price-grid">
        <Card className="price-card">
          <span className="step-chip step-chip--1">Quick fixes</span>
          <h3>Quick fixes</h3>
          <p>Remote or local on-site help, charged only for the time used.</p>
          <div className="ledger">
            <LedgerRow label="Per 30 minutes" value="$60" />
            <LedgerRow label="Equivalent hourly rate" value="$120" />
            <LedgerRow label="Local call-out fee" value="$0" />
          </div>
          <p className="fine-muted">Good for troubleshooting, small website changes, email, devices, software and mystery problems.</p>
        </Card>
        <Card className="price-card">
          <span className="step-chip step-chip--2">On-site days</span>
          <h3>On-site days</h3>
          <p>Focused time at your business when there is a useful list to work through.</p>
          <div className="ledger">
            <LedgerRow label="Half day" value="$440" />
            <LedgerRow label="Full day" value="$840" />
            <LedgerRow label="Local travel" value="$0" />
          </div>
          <p className="fine-muted">Good for setup days, clean-ups, staff help, multiple fixes and improvements that are easier in person.</p>
        </Card>
        <Card className="price-card">
          <span className="step-chip step-chip--3">Projects</span>
          <h3>Projects</h3>
          <p>Scoped and quoted up front when the work is better treated as a project than a ticking clock.</p>
          <div className="ledger"><LedgerRow label="Project price" value="quoted" /></div>
          <p className="fine-muted">Good for automation, integrations, websites, dashboards, training and broader improvements.</p>
        </Card>
      </section>
      <section className="site-wrap always-block">
        <h2>Always included</h2>
        <div className="always-ledger">
          <div className="proof-row"><span className="proof-glyph" aria-hidden="true">✓</span><span>A free initial look at the problem</span></div>
          <div className="proof-row"><span className="proof-glyph" aria-hidden="true">✓</span><span>A clear explanation of the recommended next step</span></div>
          <div className="proof-row"><span className="proof-glyph" aria-hidden="true">✓</span><span>Expected costs explained before you commit</span></div>
          <div className="proof-row"><span className="proof-glyph" aria-hidden="true">✓</span><span>Scope changes discussed before they cost more</span></div>
          <div className="proof-row"><span className="proof-glyph" aria-hidden="true">✓</span><span>Parts and materials passed through at cost</span></div>
        </div>
      </section>
    </PageShell>
  );
}
